<template>
  <div class="referral-container">
    <!-- 顶部标题区域 -->
    <div class="header-section">
      <div class="title-wrapper">
        <div class="main-title">智慧数据中心管理平台</div>
        <div class="subtitle">打造智能化、高效率的数据中心运维解决方案</div>
      </div>
    </div>

    <!-- 系统概述区域 -->
    <div class="section system-overview">
      <div class="section-title">
        <span class="icon">📊</span>
        <h2>系统概述</h2>
      </div>
      <div class="content-card">
        <p>本平台是一套先进的数据中心管理系统，致力于提供全方位的数据中心运维管理解决方案。通过整合多园区资源、智能化运维工具和高效的工单管理，实现数据中心的智能化运营。</p>
      </div>
    </div>

    <!-- 核心功能区域 -->
    <div class="section core-features">
      <div class="section-title">
        <span class="icon">🎯</span>
        <h2>核心功能</h2>
      </div>
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-icon">🏢</div>
          <h3>多园区管理</h3>
          <p>覆盖上海、杭州、清远等多个园区，实现统一管理和资源调配</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">🔧</div>
          <h3>智能运维</h3>
          <p>提供服务器部署、网络配置、故障诊断等全方位运维支持</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">📝</div>
          <h3>工单系统</h3>
          <p>高效的工单管理流程，快速响应各类运维需求</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">📈</div>
          <h3>资源监控</h3>
          <p>实时监控服务器、网络等资源状态，提供可视化数据分析</p>
        </div>
      </div>
    </div>

    <!-- 技术优势区域 -->
    <div class="section tech-advantages">
      <div class="section-title">
        <span class="icon">💡</span>
        <h2>技术优势</h2>
      </div>
      <div class="advantages-list">
        <div class="advantage-item">
          <div class="advantage-number">01</div>
          <div class="advantage-content">
            <h3>智能化管理</h3>
            <p>采用先进的AI算法，实现智能化资源调度和故障预测</p>
          </div>
        </div>
        <div class="advantage-item">
          <div class="advantage-number">02</div>
          <div class="advantage-content">
            <h3>高效协同</h3>
            <p>多角色协作机制，提升团队运维效率</p>
          </div>
        </div>
        <div class="advantage-item">
          <div class="advantage-number">03</div>
          <div class="advantage-content">
            <h3>安全可靠</h3>
            <p>多重安全防护机制，确保数据中心安全运行</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Referral',
  data() {
    return {
      systemOverview: {
        title: '系统概述',
        content: '本平台是一套先进的数据中心管理系统，致力于提供全方位的数据中心运维管理解决方案。通过整合多园区资源、智能化运维工具和高效的工单管理，实现数据中心的智能化运营。'
      },
      features: [
        {
          icon: '🏢',
          title: '多园区管理',
          description: '覆盖上海、杭州、清远等多个园区，实现统一管理和资源调配'
        },
        {
          icon: '🔧',
          title: '智能运维',
          description: '提供服务器部署、网络配置、故障诊断等全方位运维支持'
        },
        {
          icon: '📝',
          title: '工单系统',
          description: '高效的工单管理流程，快速响应各类运维需求'
        },
        {
          icon: '📈',
          title: '资源监控',
          description: '实时监控服务器、网络等资源状态，提供可视化数据分析'
        }
      ],
      advantages: [
        {
          number: '01',
          title: '智能化管理',
          description: '采用先进的AI算法，实现智能化资源调度和故障预测'
        },
        {
          number: '02',
          title: '高效协同',
          description: '多角色协作机制，提升团队运维效率'
        },
        {
          number: '03',
          title: '安全可靠',
          description: '多重安全防护机制，确保数据中心安全运行'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.referral-container {
  padding: 20px;
  background: #fff;
  min-height: 100vh;
  color: #333;

  .header-section {
    text-align: center;
    padding: 20px 0;
    background: #ffffff;
    border-radius: 12px;
    margin-bottom: 25px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .title-wrapper {
      position: relative;
      z-index: 1;
    }

    .main-title {
      font-size: 2.5em;
      margin-bottom: 15px;
      color: #333;
      font-weight: 600;
      letter-spacing: 1px;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.02);
      }
    }

    .subtitle {
      font-size: 1.2em;
      color: #666;
      font-weight: 300;
      letter-spacing: 0.5px;
    }

    @keyframes moveLight {
      0% {
        transform: translate(-50%, -50%) rotate(0deg);
      }
      100% {
        transform: translate(-50%, -50%) rotate(360deg);
      }
    }
  }

  .section {
    margin-bottom: 40px;
    padding: 30px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .section-title {
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      .icon {
        font-size: 1.5em;
        margin-right: 10px;
      }

      h2 {
        font-size: 1.8em;
        color: #333;
        margin: 0;
      }
    }
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;

    .feature-card {
      padding: 25px;
      background: #fff;
      border-radius: 8px;
      transition: transform 0.3s ease;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      &:hover {
        transform: translateY(-5px);
      }

      .feature-icon {
        font-size: 2em;
        margin-bottom: 15px;
      }

      h3 {
        color: #333;
        margin-bottom: 10px;
      }

      p {
        color: #666;
        line-height: 1.6;
      }
    }
  }

  .advantages-list {
    .advantage-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 30px;
      padding: 20px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      .advantage-number {
        font-size: 2em;
        font-weight: bold;
        color: #333;
        margin-right: 20px;
      }

      .advantage-content {
        h3 {
          color: #333;
          margin-bottom: 10px;
        }

        p {
          color: #666;
          line-height: 1.6;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .features-grid {
      grid-template-columns: 1fr;
    }

    .header-section {
      padding: 40px 0;

      .main-title {
        font-size: 2em;
      }
    }
  }
}
</style>